<template>
  <ul class="phn ptn pbxxl">
    <li
      v-for="(item, index) of items"
      :key="index"
      :class="isOpenItem(item) ? 'active-menu phm' : null"
    >
      <a
        v-if="(isOpenItem(item) && openParentItem) || (isOpenItem(item) && openParentItem == null)"
        class="pvm phs back-button"
        :tabindex="'0'"
        @keyup.enter="toggleCollapsed(item)"
        @click="toggleCollapsed(item)"
      >
        <i
          class="prs fas fa-caret-left"
          aria-hidden="true"
        />
        <span v-html="openParentItem == null ? 'Menu' : openParentItem.post_title" />
      </a>
      <a
        v-show="isOpenItem(item)"
        ref="activeTitle"
        class="active-title pvm phs"
        :tabindex="'-1'"
        @click.prevent
      >
        <div v-html="item.post_title" />
      </a>
      <a
        v-if="!isOpenItem(item)"
        :href="item.children ? null : translateLink(item.post_link)"
        class="menu-item pvm phm underline"
        :tabindex="'0'"
        @keyup.enter="toggleCollapsed(item)"
        @click="toggleCollapsed(item)"
      >
        <div class="title-container">
          <span v-html="item.post_title" />
          <div
            v-if="item.post_description"
            class="description"
            v-html="item.post_description"
          />
        </div>
        <i
          v-if="item.children"
          class="fas fa-caret-right"
        />
      </a>
      <Menu
        v-if="item.children && !item.collapsed"
        :items="item.children"
        :open-parent-item="openItem"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: "Menu",
  props: {
    items: {
      type: Array,
      required: true,
    },
    openParentItem: {
      type: Object,
      default: null,
    },
  },
  data: function() {
    return {
      openItem: null,
    };
  },
  computed: {
    currentRouteName() {
      return this.isTranslated(window.location.pathname);
    },
  },
  created() {
    let vm = this;
    vm.focusOnFirstLink();
  },
  methods: {
    toggleCollapsed(item) {
      let vm = this;
      if (item.children) {
        item.collapsed = !item.collapsed;
        if (!item.collapsed) {
          vm.openItem = item;
        } else {
          vm.openItem = null;
        }
      } else {
        window.location.href = item.post_link;
      }
    },
    isOpenItem(item) {
      let vm = this;
      if (vm.openItem) {
        return item.ID == vm.openItem.ID;
      }
      return false;
    },
    focusOnFirstLink() {
      if (this.$refs.activeTitle) {
        this.$refs.activeTitle.focus();
      }
    },
    isTranslated(path) {
      let splitPath = path.split("/");
      const langList = [ 'zh', 'es','ar', 'fr', 'ru', 'ms', 'hi', 'pt', 'bn', 'id', 'sw', 'ja', 'de', 'ko', 'it', 'fa', 'tr', 'nl', 'te', 'vi', 'ht' ];
      for (let i = 0; i < splitPath.length; i++) {
        if (langList.indexOf(splitPath[i]) > -1) {
          return '/'+splitPath[i];
        }
      }
      return null;
    },
    translateLink(link) {
      let self = this;
      let sanitizedLink = link.replace(/https?:\/\/www.phila.gov/g, '')
        .replace(/https?:\/\/admin.phila.gov/g, '');
      return self.currentRouteName ? self.currentRouteName+sanitizedLink : sanitizedLink;
    },
  },
};
</script>
